import { Component, Vue, Prop } from 'vue-property-decorator';
import template from './text-with-number.vue';
import CellData from '../../CellData';

@Component({
  mixins: [template],
})
export default class TextWithNumber extends Vue {
  @Prop()
  data!: CellData;

  @Prop()
  iconUrl: string;

  @Prop()
  counterText!: string;

  get cellData(): CellData {
    return this.data;
  }
}
